export const isInvalid = (meta: Object = {}) => {
  const { submitError, dirtySinceLastSubmit, error, touched } = meta;

  return (!!error || !!submitError) && !!touched && !dirtySinceLastSubmit;
};
